import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-88194c12"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "space-y-1 text-center" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["src"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "text-sm text-gray-600" }
const _hoisted_7 = {
  for: "file-input",
  class: "relative cursor-pointer rounded-md border border-orange-700 px-3 py-1.5 text-orange-700"
}
const _hoisted_8 = { class: "mt-4 text-xs text-gray-500" }

import { ref, Ref } from "vue";
import { useI18n } from "vue-i18n";
import { useCustomToast } from "@/composables/toast";
import msProjectIcon from "../../../assets/imgs/icon-ms-project.png";


export default /*#__PURE__*/_defineComponent({
  __name: 'FileInputPlanner',
  emits: ["updateFile"],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const isDragging = ref(false) as Ref<boolean>;
const fileName = ref("") as Ref<string>;
const allowedExtensions = [".xml"];
const { t } = useI18n();
const toast = useCustomToast();

const onFileChange = (e: Event) => {
  const target = e.target as HTMLInputElement;
  const file = target.files?.[0];
  if (!file || !checkFileExtension(file)) {
    return;
  }
  emit("updateFile", file);
};
const dragover = (e: DragEvent) => {
  isDragging.value = true;
  e.preventDefault();
};
const dragleave = () => {
  isDragging.value = false;
};
const drop = (e: DragEvent) => {
  e.preventDefault();
  isDragging.value = false;
  const file = e?.dataTransfer?.files[0];
  if (!file || !checkFileExtension(file)) {
    return;
  }
  emit("updateFile", file);
};

const fileInput = ref(null) as Ref<HTMLInputElement | null>;

const handleClick = () => {
  if (fileInput.value) {
    fileInput.value?.click();
  }
};

const checkFileExtension = (file: File) => {
  const fileExtension = file.name.substring(file.name.lastIndexOf("."));
  if (!allowedExtensions.includes(fileExtension)) {
    toast.error(t("analytics.planner.wrong_file_format"));
    return false;
  }
  return true;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["relative mt-1 flex justify-center rounded-md border-2 border-dashed border-gray-300 px-6 py-5", { 'bg-gray-200': isDragging.value }]),
    onDragover: dragover,
    onDragleave: dragleave,
    onDrop: drop
  }, [
    _createElementVNode("div", _hoisted_1, [
      (fileName.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("img", {
              src: _unref(msProjectIcon),
              alt: ""
            }, null, 8, _hoisted_3),
            _createTextVNode(" " + _toDisplayString(fileName.value), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("img", {
              src: _unref(msProjectIcon),
              alt: "",
              class: "mx-auto mb-3 h-16 w-16 cursor-pointer",
              onClick: handleClick
            }, null, 8, _hoisted_5),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("label", _hoisted_7, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("analytics.planner.label_upload_planner")), 1),
                _createElementVNode("input", {
                  ref_key: "fileInput",
                  ref: fileInput,
                  id: "file-input",
                  class: "hide-file-input p-o absolute h-1 w-1 overflow-hidden whitespace-nowrap border-0",
                  type: "file",
                  accept: "application/xml",
                  onChange: _cache[0] || (_cache[0] = ($event: any) => (onFileChange($event)))
                }, null, 544)
              ]),
              _createElementVNode("p", null, _toDisplayString(fileName.value), 1),
              _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("analytics.planner.plan_upload_desc")), 1)
            ])
          ]))
    ])
  ], 34))
}
}

})